export const mcpUrl = (apiBaseUrl = process.env.REACT_APP_API_BASE_URL) =>
  `${(apiBaseUrl || 'https://crm.conem.com.mx/api').replace(/\/+$/, '')}/mcp`;

export const tokenStatus = (token, now = new Date()) => {
  if (token.revokedAt) return { label: 'Revocado', color: 'default' };
  if (token.expiresAt && new Date(token.expiresAt) <= now) return { label: 'Vencido', color: 'warning' };
  return { label: 'Activo', color: 'success' };
};

export const claudeCodeCommand = (token, apiBaseUrl) => {
  const url = mcpUrl(apiBaseUrl);
  const name = url.includes('localhost') ? 'conem-local' : 'conem';
  return `claude mcp add --transport http ${name} ${url} --header "Authorization: Bearer ${token}"`;
};
